<div class="ef-page">

  <!-- ── HEADER ─────────────────────────────────────────────── -->
  <div class="ef-header">
    <div class="ef-header__icon"><mat-icon>assignment</mat-icon></div>
    <div>
      <h1 class="ef-header__title">Retenciones IRPF</h1>
      <p class="ef-header__sub">Facturas emitidas con retención a cuenta</p>
    </div>

    <div class="ef-header__controls">
      <app-select class="trimester-select" name="trimester" [(ngModel)]="trimester" (ngModelChange)="change()"
        [config]="{ label: 'Trimestre', options: trimesterOptions }">
      </app-select>

      <button mat-flat-button class="ef-btn-save" (click)="export()" [disabled]="spinner || irpfList.length === 0">
        <mat-icon>file_download</mat-icon> Excel
      </button>
    </div>
  </div>

  <!-- ── LOADING ──────────────────────────────────────────────── -->
  <div class="ef-loading" *ngIf="spinner">
    <div class="lf-box">
      <div class="lf-icon"><mat-icon>assignment</mat-icon></div>
      <div class="lf-dots"><span></span><span></span><span></span></div>
      <p class="lf-text">Cargando retenciones…</p>
    </div>
  </div>

  <!-- ── BODY ───────────────────────────────────────────────── -->
  <div class="ef-body" *ngIf="!spinner">

    <!-- Tarjetas resumen -->
    <div class="ef-summary-cards" *ngIf="irpfList.length > 0">
      <div class="ef-card">
        <span class="ef-card__label">Facturas</span>
        <span class="ef-card__value">{{ irpfList.length }}</span>
      </div>
      <div class="ef-card">
        <span class="ef-card__label">Base total</span>
        <span class="ef-card__value">{{ totalBase | number:'1.2-2' }} €</span>
      </div>
      <div class="ef-card ef-card--highlight">
        <span class="ef-card__label">Retención total</span>
        <span class="ef-card__value">{{ totalAmount | number:'1.2-2' }} €</span>
      </div>
    </div>

    <!-- Tabla -->
    <div class="ef-section" *ngIf="irpfList.length > 0">
      <app-table
        [columns]="headerTable"
        [dataSource]="irpfList"
        [hasButton]="true"
        [actionsTemplate]="actionsButtons"
        [showTotals]="true" [showTotalsHasOptionToPay]="false"
        [textPaided]="'Cobrado'" [textUnpaid]="'No cobrado'"
        [hasSelect]="true">
      </app-table>

      <ng-template #actionsButtons let-uid="uid">
        <ng-container *ngFor="let row of (irpfList | filter : uid : 'uid'); trackBy: trackByIndex">
          <ul class="custom-class">
            <li *ngIf="row.isInvoice === true" (click)="pdf(row.invoiceUid, row.invoiceNumber)">
              <a><mat-icon>picture_as_pdf</mat-icon> PDF</a>
            </li>
            <li *ngIf="row.isInvoice === false" class="no-pdf">
              <mat-icon>block</mat-icon> Sin PDF
            </li>
          </ul>
        </ng-container>
      </ng-template>
    </div>

    <!-- Estado vacío -->
    <div class="ef-empty" *ngIf="empty && irpfList.length === 0">
      <mat-icon>receipt</mat-icon>
      <p>No hay facturas con IRPF en el trimestre seleccionado.</p>
    </div>

    <!-- Estado inicial (sin selección) -->
    <div class="ef-empty" *ngIf="!empty && irpfList.length === 0 && !trimester">
      <mat-icon>touch_app</mat-icon>
      <p>Selecciona un trimestre para ver las retenciones.</p>
    </div>

  </div>

</div>
